import { GoogleAnalytics } from '../services/google-analytics';
import { GymResolver } from '../services';
import { resetTheme } from '../theme';

let currentLogoutFunction = () => {
  throw new Error('no logout function set');
};

let reduxDispatch = () => {
  throw new Error('dispatch not set');
};

export const LOGOUT = 'LOGOUT';

export default async function Logout(routeToLoad) {
  GymResolver.clearGyms();
  resetTheme();
  reduxDispatch({ type: LOGOUT });
  currentLogoutFunction(routeToLoad);
  const googleAnalytics = new GoogleAnalytics();
  googleAnalytics.logEventWithParamaters('logout');
  googleAnalytics.setUserId(null);
}

export function SetLogoutFunction(dispatch, logoutFunciton) {
  reduxDispatch = dispatch;
  currentLogoutFunction = logoutFunciton;
}
